module.exports = __webpack_public_path__ + "img/Weapon_147.22382113.png";